import { convertFormGiToBillingRequirement, isStorageBillingUnit, normalizeQuantityUnit } from '../../../../components/quantityUnit';
import type { ResourceType } from '../../../../platform/pipeline-kernel/types';
import { pickPricingResourceMeta } from '../../../../utils/pricingResourceMeta';

export function resolveRequirement(value: unknown): string {
  return value != null && value !== '' ? String(value) : '1';
}

export function toResourceConfig(
  template: ResourceType,
  params: {
    vendor?: string;
    device?: string;
    deviceType?: string;
    vendorID?: string;
    deviceID?: string;
    requirement?: unknown;
    quantityUnit?: string;
  },
): ResourceType | null {
  const hasVendorInfo = params.vendor || params.device || params.deviceType || params.vendorID || params.deviceID;
  const hasFormRequirement = params.requirement != null && params.requirement !== '';
  if (!hasVendorInfo && !hasFormRequirement) return null;

  const quantityUnit = normalizeQuantityUnit(params.quantityUnit);
  let requirement = resolveRequirement(params.requirement);
  // 存储类：表单 Gi → 计费项单位
  if (isStorageBillingUnit(quantityUnit) && quantityUnit !== 'Gi') {
    requirement = convertFormGiToBillingRequirement(requirement, quantityUnit) ?? requirement;
  }
  return {
    code: template.code,
    description: template.description,
    unit: template.unit,
    ...pickPricingResourceMeta(
      {
        vendor: params.vendor,
        device: params.device,
        deviceType: params.deviceType,
        vendorID: params.vendorID,
        deviceID: params.deviceID,
        quantityUnit,
      },
      requirement,
    ),
    requirement,
  };
}
